export const COMMUNICATION_TYPE = {
  EMAIL: 'email',
  TEXT: 'text',
};

export const COMMUNICATION_TYPES = [
  { name: COMMUNICATION_TYPE.EMAIL, icon: 'email' },
  { name: COMMUNICATION_TYPE.TEXT, icon: 'phone' },
];

